/** What activating an interactive control does: navigate to its destination,
 *  open the page's iframe modal, or open the page's legal modal. Link and
 *  Button share one vocabulary; each re-exports it under its own name
 *  (`LinkAction` / `ButtonAction`) so a call site imports the action from the
 *  component it is setting. */
export type ControlAction = "redirect" | "iframe_modal" | "legal_modal";

/** The published actions, so a CMS string can never reach the DOM as a bogus
 *  value — anything off this set falls back to the consumer's default
 *  (`redirect` for Link and Button). ⚠ Matched with
 *  `hasOwnProperty`, so an authored value has to be byte-identical. */
export const CONTROL_ACTIONS: Record<ControlAction, true> = {
  redirect: true,
  iframe_modal: true,
  legal_modal: true
};
